import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import { messageListLoadEpicReducer } from "./messageList.duck.js";
import { reduxActionTypePrefix, reduxKeys } from "../constants/constants.js";
import MessagesResource from "../resources/Messages.resource.js";
const actionTypesPrefix = reduxActionTypePrefix + "/dismissAllMessages";
const messageDismissAllEpicReducerArg = {
  actionPrefix: actionTypesPrefix,
  reduxKeyNested: () => [reduxKeys.value],
  loadResource: (request) => MessagesResource.dismissAllMessages(request.workspaceId, request.lastMessageId),
  onCompleteSuccess: (dismissResult, inputPayload) => (dismissResult == null ? void 0 : dismissResult.Value) || 0,
  afterActionsOnSuccess: (inputPayload, outputPayload) => loadMessagesAndRefreshCount(inputPayload, outputPayload)
};
const messageDismissAllEpicReducer = loadResourcesUtils(messageDismissAllEpicReducerArg);
const loadMessagesAndRefreshCount = (inputPayload, outputPayload) => [
  messageListLoadEpicReducer.actionCreators.load({
    workspaceId: inputPayload.workspaceId,
    loadCount: 0,
    needNewMessage: false,
    lastMessageId: -1
  })
];
const messageDismissAllReducerStateDefault = {
  value: getDefaultAsyncWrapperObj()
};
const messageDismissAllReducer = (state = messageDismissAllReducerStateDefault, action) => {
  state = messageDismissAllEpicReducer.reduxChange(state, action);
  return state;
};
export {
  messageDismissAllReducer as default,
  messageDismissAllEpicReducer,
  messageDismissAllReducer,
  messageDismissAllReducerStateDefault
};
//# sourceMappingURL=messageDismissAll.duck.js.map
